import React, { useContext, useEffect } from 'react'
import { Drawer, Layout, Button } from 'antd'
import { MenuOutlined } from '@ant-design/icons'

import { ThemeContext } from '../../context/themeContext'
import { MenuContext } from '../../context/menuContext'
import { DARK_THEME, LIGHT_THEME } from '@vacationtracker/shared/constants/ThemeSetting'
import { TAB_SIZE } from '@vacationtracker/shared/constants/sizes'
import { sidebarTracker } from './services/sidebarTracking'

import SidebarContent from './SidebarContent'

const { Sider } = Layout

interface ISidebar {
  onLogout: Function
}

const Sidebar = ({ onLogout }: ISidebar) => {

  const themeContext = useContext(ThemeContext)
  const menuContext = useContext(MenuContext)
  const onToggleCollapsedNav = () => {
    const newNavCollapsedState = !menuContext.navCollapsed

    // Track the collapse/expand action
    sidebarTracker.trackCollapseToggle({
      action: newNavCollapsedState ? 'expand' : 'collapse',
      isMiniMenu: menuContext.miniMenu,
      isTablet: menuContext.collapseNavbar,
      isMobileDrawer: true,
    })

    menuContext.setNavCollapsed(newNavCollapsedState)
  }

  const updateWindowWidth = () => {
    menuContext.setCollapseNavbar(window.innerWidth < TAB_SIZE)
    // Don't override miniMenu on resize - let user control this on desktop
  }

  useEffect(() => {
    // Set initial state based on current window size
    updateWindowWidth()

    window.addEventListener('resize', updateWindowWidth)
    return () => window.removeEventListener('resize', updateWindowWidth)
  }, [])


  return (
    <>
      <Sider
        width="280"
        trigger={null}
        collapsed={menuContext.collapseNavbar || menuContext.miniMenu}
        theme={themeContext.theme === DARK_THEME ? DARK_THEME : LIGHT_THEME}
        collapsible>
        <SidebarContent onLogout={onLogout}/>
      </Sider>

      {/* Floating menu button for tablets - only show when drawer is closed
          navCollapsed=true means drawer is OPEN,
          so we check !navCollapsed to show button when drawer is CLOSED */}
      {menuContext.collapseNavbar && !menuContext.navCollapsed && (
        <Button
          className="tablet-menu-button"
          icon={<MenuOutlined />}
          onClick={onToggleCollapsedNav}
          size="large"
        />
      )}

      {/* Drawer for collapsed sidebar */}
      {menuContext.collapseNavbar && (
        <Drawer
          className={'drawer-sidebar vt-header-wrapper mobile-navigation-drawer'}
          placement="left"
          closable={false}
          onClose={onToggleCollapsedNav}
          open={menuContext.navCollapsed}
          styles={{
            body: { padding: 0 },
          }}>
          <SidebarContent onLogout={onLogout} isMobileDrawer={true} onItemClick={onToggleCollapsedNav}/>
        </Drawer>
      )}
    </>
  )
}
export default Sidebar
